<template>
  <div class="footer-wrapper">
    <!-- Brand Logos Section (Common for all pages) -->
    <div class="brand-logos-container py-4 bg-white">
      <div class="container text-center">
        <div
          class="brand-logos-flex d-flex align-items-center justify-content-center flex-wrap gap-3 gap-md-4"
        >
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/danimal-footerlogo.png"
            alt="Danimals"
            class="brand-logo"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/silk-footerlogo.png"
            alt="Silk"
            class="brand-logo"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/toogood-footerlogo.png"
            alt="Too Good!"
            class="brand-logo"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/oikos-footerlogo.png"
            alt="Oikos"
            class="brand-logo"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/lightfit-footerlogo.png"
            alt="Light + Fit"
            class="brand-logo"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/activia-footerlogo.png"
            alt="Activia"
            class="brand-logo"
          />
        </div>
      </div>
    </div>

    <!-- Legal Disclaimers Copy Above Footer Bar -->
    <div class="container py-4">
      <div v-html="$t('Footer.legalrules')" class="disclaimer-copy"></div>
    </div>

    <!-- Black Footer Bar -->
    <footer class="py-4">
      <div class="container">
        <!-- Desktop Footer Layout -->
        <div class="row align-items-center justify-content-between d-md-flex">
          <div class="col-md-8 text-center text-md-start">
            <ul class="list-inline mb-2" id="footer-nav-desktop">
              <li
                class="list-inline-item ps-0"
                v-html="$t('Footer.T&CLink')"
              ></li>
              <li
                class="list-inline-item"
                v-html="$t('Footer.PrivayPolicyLink')"
              ></li>
              <li
                class="list-inline-item"
                v-html="$t('Footer.ContactUsLink')"
              ></li>
              <li class="list-inline-item" v-html="$t('Footer.DNSLink')"></li>
            </ul>
            <p
              class="copyright-copy mb-0"
              v-html="$t('Footer.copyrighttext')"
            ></p>
          </div>

          <div class="col-md-4 text-center text-md-end mt-3 mt-md-0">
            <div
              class="social-nav d-inline-flex align-items-center justify-content-center"
            >
              <span class="follow-label me-2">{{ $t('Footer.FollowUs') }}</span>
              <a
                href="https://www.facebook.com/DanoneNorthAmerica/"
                class="social-icon"
                title="Facebook"
                target="_blank"
              >
                <i class="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://x.com/danoneNA"
                class="social-icon"
                title="X (Twitter)"
                target="_blank"
              >
                <i class="fab fa-x-twitter"></i>
              </a>
              <a
                href="https://www.instagram.com/danonenorthamerica/"
                class="social-icon"
                title="Instagram"
                target="_blank"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <!-- <a href="#" class="social-icon" title="YouTube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>-->
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'TheFooter',
};
</script>

<style scoped>
/* Page/Component-level footer styles are centralized in main.css */
</style>
